import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";

export default function RegistrationSuccessful() {
  const laung = localStorage.getItem("laung");
  const path = "Assets/scss/FirstTimeUsers.module.scss";
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  return (
    <div className="col-md-9 mx-auto signuppage new-signup-page">
      <div className="col-md-10 mx-auto text-center">
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/tick-back.svg`}
          alt=""
        />
        <h1>Welcome to UrXprt, and thank you for registering. On UrXprt, you can take part as both an Expert and a Customer, depending on the opportunity posted.</h1>
      </div>
      {/* <div className="row">
        <div className="col-md-4 signup-back">
          <div
            className="signup-sec"
            onClick={() => navigate(`/${lan}/registration`)}
          >
            //  <p>Looking for work?</p> 
            <h4>REGISTER AS AN EXPERT</h4>
          </div>
        </div>
        <div className="col-md-4 signup-back">
          <div
            className="signup-sec"
            onClick={() =>
              navigate(`/${lan}/registration`, { state: { type: 2 } })
            }
          >
            // <p>Become an Agency</p> 
            <h4>REGISTER AS A COMPANY</h4>
          </div>
        </div>
        <div className="col-md-4 signup-back">
          <div
            className="signup-sec"
            onClick={() => navigate(`/${lan}/createpost`, { state: { theType: 1 } })}
          >
          // <p>Let’s get things done</p> 
            <h4>CREATE YOUR FIRST POST</h4>
          </div>
        </div>
      </div> */}
      <div className="visit mt-0">
        <button onClick={() => navigate(`/${lan}/account`)} className="btn">
          Continue
        </button>
      </div>
    </div>
  );
}
